import React, { useState, useEffect, useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { UncontrolledTooltip } from "reactstrap";
import { Icon } from "components";
import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import s from "./ProductListLeftSidebar.module.scss";
import { useProjectDataStore } from "stores/projectStore";

export const ProductsNavigation = Scrivito.connect(({ product }) => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipId =
    (product.name || "").replace(/[^a-zA-Z0-9]/g, "") || "defaultTooltip";

  const selectedCategory = useProductsOverviewStore((state) => {
    const prodCategId = state.productCategoryId;
    if (!prodCategId) {
      return [];
    }
    return Array.isArray(prodCategId) ? prodCategId : [prodCategId];
  });

  useEffect(() => {
    setIsOpen(selectedCategory.includes(product?.key));
  }, [product, selectedCategory]);

  const {
    setProductCategoryId,
    setProductsContent,
    navigateToConfiguratorPage,
    navigateToProductListPage,
    markSidebarChange,
  } = useProductsOverviewActions();

  const projectId = useProjectDataStore((state) => state.projectId);

  const isCurrentCategory =
    product?.key &&
    selectedCategory[selectedCategory.length - 1] === product.key;

  const selectCategory = useCallback(() => {
    if (isCurrentCategory) {
      return;
    }

    if (product.link) {
      const url = product.link.get("linkForMenuItem").url();
      window.open(url, "_blank");
    } else if (product.nodes && selectedCategory !== product.keyList) {
      setProductsContent(product.nodes);
      setProductCategoryId(product.keyList);
      navigateToProductListPage({
        projectId,
        shouldKeepProductCategories: true,
      });
    } else {
      setProductCategoryId(product.keyList);

      navigateToConfiguratorPage({
        projectId,
        seriesId: `${product.serieId}`,
        shouldKeepProductCategories: true,
      });
      markSidebarChange();
    }
  }, [
    setProductsContent,
    navigateToConfiguratorPage,
    navigateToProductListPage,
    product,
    projectId,
    selectedCategory,
    setProductCategoryId,
    markSidebarChange,
    isCurrentCategory,
  ]);

  const toggleChildren = () => setIsOpen((prev) => !prev);

  return (
    <div className={cx(s.productCategory, "cursor-pointer h-auto ms-3")}>
      <div
        className={cx(
          s.productTitle,
          {
            [s.active]: selectedCategory?.includes(product?.key),
          },
          "py-2 ps-2   d-flex align-items-center justify-content-between",
        )}
      >
        <button
          id={tooltipId}
          className={cx(
            s.titleDefault,
            {
              "cursor-default": isCurrentCategory,
            },
            "me-2 p-0 h-100 w-100 text-truncate flex-grow-1 bg-transparent border-0 text-start text-white",
          )}
          onClick={selectCategory}
          disabled={isCurrentCategory}
        >
          {product.name}
        </button>

        <UncontrolledTooltip target={tooltipId} placement="top">
          {product.name}
        </UncontrolledTooltip>

        {product.nodes && (
          <button
            className="d-flex h-100 align-items-center justify-content-center mx-1 px-1 py-0 bg-transparent border-0 text-white"
            onClick={toggleChildren}
          >
            <Icon
              prefix="trox"
              iconName={isOpen ? "chevron-up-regular" : "chevron-down-regular"}
            />
          </button>
        )}
      </div>
      {isOpen &&
        product?.nodes?.map((childProduct, key) => (
          <ProductsNavigation key={key} product={childProduct} />
        ))}
    </div>
  );
});
